module.exports = __webpack_public_path__ + "static/img/zbxx-ban.af0e8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zbxx-ban.jpg
// module id = l1kg
// module chunks = 1